import React from "react";
import { inject, observer } from "mobx-react";

import { Table, TableHead, TableCell, TableRow, TableBody, Grid, Paper, Typography } from "@material-ui/core";
import { IManagementStore } from "Stores/Management/types";
import ResultsAreEmpty from "@src/Components/Ui/ResultsAreEmpty";
import { Values } from "@src/Tools/Values";
import { STTableHeadTypography } from "@src/Components/Ui/STTableHeadTypography";
import EntityDelete from "@src/Components/Common/EntityDelete/EntityDelete";
import { IValuesStore } from "@src/Stores/Values/types";
import { IAuthApplication } from "@src/Interfaces/Entity/OAuthApplication";
import AddAuthApplication from "./AddAuthApplication/AddAuthApplication";
import EditAuthApplication from "./EditAuthApplication/EditAuthApplication";
import AuthApplicationHelpModal from "./AuthApplicationHelpModal/AuthApplicationHelpModal";
import { observable, computed } from "mobx";
import { STLink, STItemGrid, STImg, STGrid } from "./styles";
import { IAuthStore } from "@src/Stores/Auth/types";
import { STTableCellTypography } from "@src/Components/Ui/STTableCellTypography";

interface IProps {
  management?: IManagementStore;
  values?: IValuesStore;
  auth?: IAuthStore;
}

@inject("auth", "management", "values")
@observer
class AuthApplicationsContent extends React.Component<IProps> {
  @observable isLoading: boolean = true;
  @observable swaggerUrl: string;

  async componentDidMount() {
    this.swaggerUrl = await this.props.values.getSwaggerUrl(false, true);
    this.isLoading = false;
  }

  @computed get oAuthApplications() {
    const currentLocation = this.props.auth.user.location;
    if (currentLocation.primary) {
      return this.props.management.oAuthApplications;
    }
    return this.props.management.oAuthApplications.filter(
      (application) => application.locationId == currentLocation.id
    );
  }

  getLocationName = (locationId: string) => {
    const location = this.props.management.locations.find((location) => location.id === locationId);
    if (!location) {
      return "";
    }
    return location.name;
  };

  hasNoLocation = (locationId: string) => {
    return locationId === "00000000-0000-0000-0000-000000000000";
  };

  handleRemove = async (id: string) => {
    await this.props.management.removeOAuthApplication(id);
  };

  render() {
    return (
      <Grid container direction="column">
        <Grid container wrap="nowrap">
          <Grid item xs={6}>
            <STGrid container justify="flex-start" align="flex-end">
              <STItemGrid item xs={3}>
                <AuthApplicationHelpModal />
              </STItemGrid>
              <STItemGrid item xs={4}>
                <STLink href={this.swaggerUrl} target="_blank">
                  <STImg
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAYFBMVEUAAABUfwBUfwBUfwBUfwBUfwBUfwBUfwBUfwBUfwBUfwBUfwBUfwBUfwBUfwB0lzB/n0BfhxBpjyC0x4////+qv4CJp1D09++ft3C/z5/K16/U379UfwDf58/q79+Ur2D2RCk9AAAAHXRSTlMAEEAwn9//z3Agv4/vYID/////////////////UMeji1kAAAD8SURBVHgBlZMFAoQwDATRxbXB7f+vPKnlXAZn6k2cf3A9z/PfOC8IIYni5FmmABM8FMhwT17c9hnhiZL1CwvEL1tmPD0qSKq6gaStW/kMXanVmAVRDUlH1OvuuTINo6k90Sxf8qsOtF6g4ff1osP3OnMcV7d4pzdIUtu1oA4V0DZoKmxmlEYvtDUjjS3tmKmqB+pYy8pD1VPf7jPE0I40HHcaBwnue6fGzgyS5tXIU96PV7rkDWHNLV0DK4FkoKmFpN5oUnvi8KoeA2/JXsmXQuokx0siR1G8tLkN6eB9sLwJp/yymcyaP/TrP+RPmbMMixcJVgTR1aUZ93oGXsgXQAaG6EwAAAAASUVORK5CYII="
                    alt={Values.getLocalizationValue("swagger")}
                  />
                  {Values.getLocalizationValue("swaggerUI")}
                </STLink>
              </STItemGrid>
            </STGrid>
          </Grid>
          <Grid item xs={6}>
            <Grid container justify="flex-end">
              <AddAuthApplication />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs>
          {this.oAuthApplications.length > 0 ? (
            <Paper elevation={2}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <STTableHeadTypography>{Values.getLocalizationValue("name")}</STTableHeadTypography>
                    </TableCell>
                    <TableCell>
                      <STTableHeadTypography>{Values.getLocalizationValue("location")}</STTableHeadTypography>
                    </TableCell>
                    <TableCell align="right" />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.oAuthApplications.map((oAuthApplication: IAuthApplication) => {
                    return (
                      <TableRow key={oAuthApplication.id}>
                        <TableCell component="th" scope="row" size="small">
                          <Typography>
                            <STTableCellTypography>{oAuthApplication.name}</STTableCellTypography>
                          </Typography>
                        </TableCell>
                        <TableCell component="th" scope="row" size="small">
                          <Typography>
                            <STTableCellTypography>
                              {this.getLocationName(oAuthApplication.locationId)}
                            </STTableCellTypography>
                          </Typography>
                        </TableCell>
                        <TableCell align="right" size="small">
                          {(this.props.auth.user.location.id === oAuthApplication.locationId || this.hasNoLocation(oAuthApplication.locationId)) && (
                            <Grid container wrap="nowrap" justify="flex-end">
                              <EditAuthApplication oAuthApplication={oAuthApplication} />
                              <EntityDelete onSubmit={() => this.handleRemove(oAuthApplication.id)} />
                            </Grid>
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </Paper>
          ) : (
            <ResultsAreEmpty />
          )}
        </Grid>
      </Grid>
    );
  }
}

export default AuthApplicationsContent;
